module.exports = __webpack_public_path__ + "img/lifechamps-gear.fbb755b0.svg";